module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_8019.092a4e19.png";